module.exports = __webpack_public_path__ + "static/media/YF77_4.907ff9fb.JPG";